<script>
import { required } from '@/utils/propTypes';

export default {
  inheritAttrs: false,
  props: {
    options: required(Array),
    value: required([String, Number]),
    label: required(String),
  },
  methods: {
    updateValue(event) {
      this.$emit('input', event.target.value);
    },
  },
};
</script>

<template>
  <label>
    {{ label }}
    <v-select
      outlined
      background-color="white"
      height="44px"
      :items="options"
      :value="value"
      v-bind="$attrs"
      v-on="$listeners"
      @change="updateValue"
    />
  </label>
</template>

<style scoped lang="scss">
label {
  display: block;
  font-weight: bold;

  * {
    font-weight: normal;
  }

  .v-text-field.v-text-field--enclosed {
    margin-top: 10px;
  }
}
</style>
